import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PublicSiteShell from '../../components/PublicSiteShell';
import { useDiscoveryStatus } from '../../hooks/useDiscoveryStatus';
import { mainSiteUrl } from '../../constants/discovery';
import DiscoveryPage from './DiscoveryPage';
import './discovery.css';

const MAIN_ORIGIN = 'https://www.haastia.com';
const DISCOVERY_DESCRIPTION = 'Join Haastia Discovery’s free founding community for independent beauty professionals. A local marketplace to explore talent, services, and booking is coming soon.';

const DiscoveryUnavailable = () => (
  <main className="discovery-unavailable">
    <p className="eyebrow">Page not found</p>
    <h1>There&rsquo;s nothing here right now.</h1>
    <p>Head back to Haastia to explore the rest of the site.</p>
    <a className="btn btn-primary" href={mainSiteUrl()}>Go to Haastia</a>
  </main>
);

const DiscoverySite = ({ isDiscoveryHost = false }) => {
  const { pathname, search, hash } = useLocation();
  const { enabled, loading } = useDiscoveryStatus();

  useEffect(() => {
    if (isDiscoveryHost && pathname !== '/') {
      window.location.replace(`${MAIN_ORIGIN}${pathname}${search}${hash}`);
    }
  }, [hash, isDiscoveryHost, pathname, search]);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = enabled ? 'Haastia Discovery | Join the founding beauty community' : 'Page not found | Haastia';
    let robots = document.querySelector('meta[name="robots"]');
    const hadRobots = Boolean(robots);
    const previousRobots = robots?.content;
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = enabled ? 'index,follow' : 'noindex,nofollow';

    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.content;
    if (enabled && description) description.content = DISCOVERY_DESCRIPTION;

    return () => {
      document.title = previousTitle;
      if (hadRobots) robots.content = previousRobots;
      else robots.remove();
      if (description) description.content = previousDescription;
    };
  }, [enabled]);

  if (isDiscoveryHost && pathname !== '/') return null;

  return (
    <PublicSiteShell>
      {loading ? <main className="discovery-unavailable" role="status">Loading Discovery…</main> :
        enabled ? <DiscoveryPage /> : <DiscoveryUnavailable />}
    </PublicSiteShell>
  );
};

export default DiscoverySite;
